import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Field } from 'react-formality'
import { TextField } from '@material-ui/core'

import connectPropTypes from './utilities/connectPropTypes'
import handlerToCallUpdateIfValid from './utilities/Data/handlerToCallUpdateIfValid'
import getField from './utilities/Data/getField'
import Form from './components/Form'
import getFieldValueInUnit from './utilities/Data/User/getFieldValueInUnit'
import Img from './components/Img'
import DistanceUnitField from './components/Edit/DistanceUnitField'

import editStyles from './Edit.icss'

class EditWeight extends React.Component {
	constructor(props) {
		super(props)

		this.handlerToCallStatisticsUpdateIfValid = handlerToCallUpdateIfValid(props.userProfileStatisticsUpdate, { history: props.history })
		this.form = React.createRef()
		this.inputRef = React.createRef()
		this.scrollTimeout = null

		props.appShowBottomBar(false)
		props.appShowBottomNavBar(true)
		props.appBottomNavBarHandleClick(() => this.form.current.submit())
	}

	componentDidMount() {
		this.props.appHeading({ text: this.context.translate('Weight measurement') })
		this.props.appBottomNavBarLabelNext(this.context.translate('Done'))
	}

	render() {
		if (!this.props.user.userProfile) {
			return null
		}

		const statistics = getField(this.props.user, 'userProfile.statistics')

		return (
			<section>
				<div className={editStyles.pagePadding}>
					<Form
						ref={this.form}
						onSubmit={({ values, isValid }) => isValid && this.props.userProfileStatisticsUpdate({ values, goBack: true, history: this.props.history })}
						className={classNames(editStyles.oneColumn)}
						initialValues={{
							weight: getFieldValueInUnit(statistics, 'weight') || '',
							weightUnit: getField(statistics, 'weight.unit') || 'kg'
						}}
					>
						{(props) => {
							if (props.isValid === false) {
								this.inputRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' })
							}
							const handlerToCallStatisticsUpdateIfValid = this.handlerToCallStatisticsUpdateIfValid(props.store)
							return (
								<React.Fragment>
									<h2>{this.context.translate('Measure your weight')}</h2>
									<Img content="/images/content/guide/weight.svg" className={editStyles.img} />
									<p>
										{this.context.translate('For most accurate measurement use a standard body weight scale and measure first thing in the morning with minimal to no clothing.')}
									</p>
									<p>
										{this.context.translate('Most recent weight measurement will do for this but it’s a good idea to keep this up to date if you are training or dieting.')}
									</p>
									<div className={editStyles.statistic}>
										<Field
											component={TextField}
											inputRef={this.inputRef}
											name="weight"
											className={editStyles.statisticValue}
											placeholder={props.values.weightUnit}
											label={this.context.translate('Weight')}
											value={props.values.weight}
											type="number"
											onBlur={handlerToCallStatisticsUpdateIfValid('weight', 'weightUnit')}
											validate={{
												presence: true,
												numericality: true
											}}
										/>
										<DistanceUnitField
											name="weightUnit"
											value={props.values.weightUnit}
											onBlur={handlerToCallStatisticsUpdateIfValid('weightUnit', 'weight')}
											onChange={props.store.setBinder('weightUnit')}
										/>
									</div>

								</React.Fragment>
							)
						}}
					</Form>
				</div>
			</section>
		)
	}
}

EditWeight.contextTypes = {
	translate: PropTypes.func
}

EditWeight.propTypes = {
	user: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	appBottomNavBarHandleClick: PropTypes.func.isRequired,
	appBottomNavBarLabelNext: PropTypes.func.isRequired,
	appHeading: PropTypes.func.isRequired,
	appShowBottomBar: PropTypes.func.isRequired,
	appShowBottomNavBar: PropTypes.func.isRequired,
	userProfileStatisticsUpdate: PropTypes.func.isRequired,
	history: PropTypes.shape({
		goBack: PropTypes.func.isRequired
	}).isRequired
}

export default connectPropTypes(EditWeight)



// WEBPACK FOOTER //
// ./src/EditWeight.jsx